import React from 'react';
import { Recommender } from '../types';
import RecommenderCard from './RecommenderCard';

interface PeopleListProps {
  people: Recommender[];
}

const PeopleList: React.FC<PeopleListProps> = ({ people }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {people.map((person, index) => (
        <div
          key={person.id}
          className="animate-slide-up opacity-0"
          style={{
            animationDelay: `${index * 50}ms`,
            animationFillMode: 'forwards'
          }}
        >
          <RecommenderCard person={person} />
        </div>
      ))}
    </div>
  );
};

export default PeopleList;